(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[797],{

/***/ 797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ InfoWithIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _InfoWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1269);
/* harmony import */ var _InfoWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_InfoWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




function InfoWithIcon(_ref) {
  var svgIcon = _ref.svgIcon,
      primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: (_InfoWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_InfoWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon),
      children: svgIcon
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: (_InfoWithIcon_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
        children: primaryText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
        children: secondaryText
      })]
    })]
  });
}

/***/ }),

/***/ 1269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoWithIcon_container__wRQL_","icon":"InfoWithIcon_icon__armf4","text":"InfoWithIcon_text__RZ2_0"};

/***/ })

}]);